//@flow
import * as actionTypes from './actionTypes';
import {
    submitTaskApi,getTaskApi,getVendorsPhoenixRestApi
} from '../../apiUtils/api';
import { transformDataToEditFormData } from './editFormData'
import { getReviewOutcome } from '../demeter/submitFormData'
import type { Dispatch$Type,ReducerState$Type,EditForm$Type,PostForm$Type } from '../genericFlowTypes'

const workflowType = 'Theia'

export const getTaskData=(theia:ReducerState$Type, jwt:string,taskAcceptedInfoId: number)=>{
    return (dispatch:Dispatch$Type) => getTaskApi(jwt,workflowType,taskAcceptedInfoId.toString())
    .then((res)=>res.json()).then((data)=>{
        const error = (data.error:any|null)
        if (error){
            dispatch({type: actionTypes.THEIA_EDIT_VERIFY_FORM_DATA_ERROR,error: error});
        }else {
            const formData = transformDataToEditFormData(data,theia)
            dispatch({
                type: actionTypes.THEIA_EDIT_VERIFY_FORM_DATA_SUCCESS, 
                formData: formData,reviewQuestions: data['reviewQuestions'] });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.THEIA_EDIT_VERIFY_FORM_DATA_ERROR, error: err});
    })
}

export const invoiceSubmissionCompleted = () => {
    return { type: actionTypes.THEIA_INV_SUBMITTED_COMPLETED };
}

export const invoiceSubmission = (jwt:any,taskAcceptedInfoId:number,theiaResultset:any,theia:ReducerState$Type)=>{
    let payload:PostForm$Type={
        taskAcceptedInfoId:taskAcceptedInfoId
    };

    if (theiaResultset.isInvalidDoc){
        payload.isInvalidDoc=true;
    }else {
        payload.depositAccount=theiaResultset.depositAccount;
        payload.insuranceCo=theiaResultset.insuranceCo;
        payload.checkDate=theiaResultset.checkDate;
        payload.checkNo=theiaResultset.checkNo;
        payload.fnameInsured=theiaResultset.fnameInsured;
        payload.lnameInsured=theiaResultset.lnameInsured;
        payload.checkAmount=theiaResultset.checkAmount;
        payload.isInvalidDoc=theiaResultset.isInvalidDoc?theiaResultset.isInvalidDoc:false;
        payload.isOverrideInsuranceCo=theiaResultset.isOverrideInsuranceCo?theiaResultset.isOverrideInsuranceCo:false;
        payload.coverPageDate=theiaResultset.coverPageDate
    }

    if (theia.reviewQuestions && theia.reviewQuestions.length > 0){
        payload.reviewOutcome=getReviewOutcome(theiaResultset,theia.reviewQuestions)
    }
    
    return (dispatch:Dispatch$Type) => submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data['error']){
            dispatch({type: actionTypes.THEIA_INV_SUBMIT_ERROR, error: data.error});
        }else {
            dispatch({type: actionTypes.THEIA_INV_SUBMIT_SUCCESS});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.THEIA_INV_SUBMIT_ERROR, error: err});
    })
}

export const updateFormError=(error:any|null)=>{
    return { type: actionTypes.THEIA_UPDATE_FORM_ERROR, formError: error }
}

export const populateVendorsList=(jwt:any)=>{
    return (dispatch:Dispatch$Type) => getVendorsPhoenixRestApi(jwt,workflowType.toLowerCase())
    .then((resp) => resp.json()).then(data =>{
        
        dispatch({type: actionTypes.REFRESH_THEIA_VENDORS_SUCCESS, vendors: data });
        
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.REFRESH_THEIA_VENDORS_ERROR, error: err});
    })
}

export const populateDepositAccountsList=(jwt:any)=>{
    return (dispatch:Dispatch$Type) => getVendorsPhoenixRestApi(jwt,'theia_depositaccounts')
    .then((resp) => resp.json()).then(data =>{
        
        dispatch({type: actionTypes.REFRESH_THEIA_DEPOSIT_ACCOUNTS_SUCCESS, depositAccounts: data });
        
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.REFRESH_THEIA_DEPOSIT_ACCOUNTS_ERROR, error: err});
    })
}



// WEBPACK FOOTER //
// ./src/redux/theia/actions.js